import React from 'react';
import {
  DataForDesignDrawingsManifold,
  DataForDesignDrawingsRoom,
} from '../../../designs/data-for-design-drawings/dataForDesignDrawingsResponse';
import { DisplayStyle } from './DisplayStyle';
import { PortRow } from './PortRow';
import { RoomRow } from './RoomRow';

type Props = {
  name: string;
  manifold: DataForDesignDrawingsManifold;
  displayStyle?: DisplayStyle;
  getValue: (room: DataForDesignDrawingsRoom) => string | number | null;
};
export const PortOrRoomRow = ({ name, manifold, displayStyle = 'PerPort', getValue }: Props) => {
  if (displayStyle === 'PerPort') {
    return <PortRow name={name} manifold={manifold} getValue={getValue} />;
  }

  return <RoomRow name={name} manifold={manifold} getValue={getValue} />;
};
